















import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import CookieLaw from 'vue-cookie-law';

@Component({
    components: {
        CookieLaw,
    },
})
export default class CookieDisclaimer extends Mixins(BaseMixin) {
    @Prop(String)
    public moreInfoLink!: string;
}
